var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.2898 3.86802L1.81978 18.008C1.64514 18.3104 1.55274 18.6533 1.55177 19.0025C1.55079 19.3518 1.64127 19.6951 1.8142 19.9985C1.98714 20.3019 2.2365 20.5548 2.53748 20.7319C2.83847 20.909 3.18058 21.0042 3.52978 21.008H20.4698C20.819 21.0042 21.1611 20.909 21.4621 20.7319C21.7631 20.5548 22.0124 20.3019 22.1854 19.9985C22.3583 19.6951 22.4488 19.3518 22.4478 19.0025C22.4468 18.6533 22.3544 18.3104 22.1798 18.008L13.7098 3.86802C13.5315 3.57412 13.2805 3.33114 12.981 3.1625C12.6814 2.99387 12.3435 2.90527 11.9998 2.90527C11.656 2.90527 11.3181 2.99387 11.0186 3.1625C10.7191 3.33114 10.468 3.57412 10.2898 3.86802Z",
  stroke: "#C72943",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 9.00806V13.0081",
  stroke: "#C72943",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12 17.0081H12.01",
  stroke: "#C72943",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgWarningOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningOutline);
export default __webpack_public_path__ + "static/media/WarningOutline.c2bcac8e.svg";
export { ForwardRef as ReactComponent };